import api from "./api";

const API_URL = "/DigitalTwinShipment";

const unwrap = (res) => res?.data ?? null;

export const createDigitalTwin = async (shipmentId) =>
    unwrap(await api.post(`${API_URL}/create/${shipmentId}`));

export const createAllDigitalTwins = async () =>
    unwrap(await api.post(`${API_URL}/create-all`));

export const getClientDigitalTwin = async (shipmentId) =>
    unwrap(await api.get(`${API_URL}/client/${shipmentId}`));

export const getDigitalTwin = async (shipmentId) =>
    unwrap(await api.get(`${API_URL}/${shipmentId}`));

export const getDigitalTwinByShipmentId = async (shipmentId) =>
    unwrap(await api.get(`${API_URL}/shipment/${shipmentId}`));

export const getDigitalTwinByTrackingNumber = async (trackingNumber) =>
    unwrap(
        await api.get(
            `${API_URL}/tracking/${encodeURIComponent(trackingNumber)}`
        )
    );

export const getLatestTelemetry = async (shipmentId) =>
    unwrap(await api.get(`${API_URL}/${shipmentId}/telemetry`));

export const updateDigitalTwinTelemetry = async (shipmentId, payload) =>
    unwrap(await api.post(`${API_URL}/${shipmentId}/telemetry`, payload));

export const updateDigitalTwinSecurityStatus = async (shipmentId, payload) =>
    unwrap(await api.post(`${API_URL}/${shipmentId}/security-status`, payload));

export const updateDigitalTwinThreatPrediction = async (shipmentId, payload) =>
    unwrap(await api.post(`${API_URL}/${shipmentId}/threat-prediction`, payload));

export default {
    createDigitalTwin,
    createAllDigitalTwins,
    getClientDigitalTwin,
    getDigitalTwin,
    getDigitalTwinByShipmentId,
    getDigitalTwinByTrackingNumber,
    getLatestTelemetry,
    updateDigitalTwinTelemetry,
    updateDigitalTwinSecurityStatus,
    updateDigitalTwinThreatPrediction,
};